/* import __COLOCATED_TEMPLATE__ from './block-freelancer-modal.hbs'; */
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import { closeModal, showNextModal } from 'sh-www/utils/modal-controls';
import { clearErrors, handleErrorResponseWithModal, setErrors } from 'sh-www/utils/handles-errors';
import { SH_CUSTOM_ERROR_CODES, SH_ERROR_INDEX } from 'sh-www/utils/adapter-errors';
import LSGModalBase from './lsg/lsg-modal-dialog-base';

export default LSGModalBase.extend({
  /**
   * Register services
   */
  userCommandService : service('commands/user-commands'),

  /**
   * @inheritDoc
   */
  propertyDefaults: {
    /**
     * @param {User|null}   The user we'll take action on
     */
    freelancerProfile: null,
  },

  /**
   * @type {Boolean}      Will be set to true after the user confirms the (un)block action
   */
  _isActionConfirmed: false,

  /**
   * @type {Boolean}    True if freelancer is blocked
   */
  _isFreelancerBlocked: readOnly('model.freelancerProfile.isBlocked'),

  /**
   * @type {Boolean}    True while we're saving the updated status.
   */
  _isSaving: false,

  /**
   * @type {String}     The message about (un)blocking the user
   */
  _note: '',

  /**
   * @type {String}     Message for text area placeholder
   */
  _textAreaPlaceholder: computed('_isFreelancerBlocked', function() {
    return this.get('_isFreelancerBlocked') ? 'Why are you unblocking this creator?' : 'Why are you blocking this creator?'
  }),

  init() {
    this._super(...arguments);
    this.set('errors', {});
  },

  /**
   * @inheritDoc
   */
  _onClose() {
    this.set('_note', '');
    this.set('_isActionConfirmed', false);
    this.set('_isSaving', false);
  },

  actions: {
    closeModal() {
      closeModal(this);
    },

    /**
     * User confirmed the (un)block action
     */
    onActionConfirmed: function() {
      clearErrors(this);

      let note = this.get('_note');
      if (!note) {
        setErrors(this, { 'note-error': 'You enter must a note.' }, ['note-error'], true);
        return;
      }

      this.set('_isSaving', true);
      if (this.get('_isFreelancerBlocked')) {
        this.get('userCommandService').unblockUser(this.get('model.freelancerProfile'), note)
          .then(() => this.set('_isActionConfirmed', true))
          .finally(() => {
            this.set('_isSaving', false);
          });
      } else {
        this.get('userCommandService').blockUser(this.get('model.freelancerProfile'), note)
          .then(() => this.set('_isActionConfirmed', true))
          .catch(e => {
            let errors = e.errors;

            if (errors[SH_ERROR_INDEX.CUSTOM_ERROR_CODE] === SH_CUSTOM_ERROR_CODES.ERROR_CODE_USER_HAS_OPEN_PROJECTS) {
              let modalModel = {
                titleText: 'Can\'t block ' + this.get('model.freelancerProfile.fullName'),
                bodyText: 'To block this freelancer, first complete or cancel your current projects with them.',
                actionButtonText: 'OK',
                confirmAction: () => {

                }
              };

              showNextModal(this, 'confirmation', modalModel);
              return;
            }

            handleErrorResponseWithModal(this, e);
          }).finally(() => {
            this.set('_isSaving', false);
          });
      }
    }
  }
});
